import * as React from 'react';
import { Fragment } from 'react';
import Pagination from '../components/Pagination';
import { BulkActionProps, BulkDeleteButton, DateInput, List, ListProps } from 'react-admin';
import { OrganizationCoachNotificationList } from './OrganizationCoachNotificationList';
import { OrganizationCoachNotificationDatagrid } from './OrganizationCoachNotificationDatagrid';
import { Theme, useMediaQuery } from '@material-ui/core';
import { ExportField, generateExporter } from '../util/Exporter';
import { OrganizationCoachNotification } from './OrganizationCoachNotification';

export * from './OrganizationCoachNotification';
export * from './OrganizationCoachNotificationCreate';
export * from './OrganizationCoachNotificationDatagrid';
export * from './OrganizationCoachNotificationEdit';
export * from './OrganizationCoachNotificationList';
export * from './OrganizationCoachNotificationShow';

const OrganizationCoachNotificationsBulkActionButtons = (props: BulkActionProps) => (
	<Fragment>
		<BulkDeleteButton {...props} undoable={false}/>
	</Fragment>
);

export const exportFields: ExportField[] = [
	{ key: 'id', header: 'ID' },
	{ key: 'title', header: 'Title' },
	{ key: 'body', header: 'Body' },
	{ key: 'numberOfDaysSinceClientStart', header: 'Number of Days Since Client Start' }
];

export const OrganizationCoachNotificationsData = (props: ListProps): React.ReactElement => {
	const isXSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('xs'));
	const exportDataMapper = (entity: OrganizationCoachNotification) => entity;

	const organizationCoachNotificationsFilter = [
		<DateInput source="from__createdAt" label="FROM_CREATED_AT"
		           alwaysOn/>,
		<DateInput source="to__createdAt" label="TO_CREATED_AT"
		           alwaysOn/>
	];

	return (
		<Fragment>
			<List
				exporter={generateExporter('פולואפים מאמנים', exportFields, exportDataMapper)}
				{...props}
				filters={organizationCoachNotificationsFilter}
				bulkActionButtons={<OrganizationCoachNotificationsBulkActionButtons/>}
				title="COACH_FOLLOWUPS"
				sort={{ field: 'numberOfDaysSinceClientStart', order: 'ASC' }}
				perPage={20}
				pagination={<Pagination/>}
			>
				{isXSmall ? <OrganizationCoachNotificationList/> : <OrganizationCoachNotificationDatagrid/>}
			</List>
		</Fragment>
	);
};
